import { BrowserRouter } from "react-router-dom";
import Layout from "./layout/index";
import { Provider } from "react-redux";
import store from "./redux/store";
import ScrollToTop from "./router/ScrollToTop";

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <ScrollToTop />
        <Layout />
      </BrowserRouter>
    </Provider>
  );
}

export default App;
